module.exports = __webpack_public_path__ + "static/media/alarm.0323ae07.mp3";